import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = ["title"]

import { onMounted } from "vue";
import { Obstacle } from "@/models/Obstacle";

export default /*@__PURE__*/_defineComponent({
  __name: 'GameGrid',
  props: ["gridSize", "rover", "obstacles"],
  setup(__props) {

const props = __props;
const isObstacle = (x: number, y: number) => {
  return positionObstacle.has(x + "," + y);
};

const positionObstacle = new Set<string>();

props.obstacles.forEach((obstacle: Obstacle) => {
  positionObstacle.add(
    obstacle.getPosition().x + "," + obstacle.getPosition().y
  );
});

const isRober = (x: number, y: number) => {
  return (
    props.rover?.getPosition()?.x === x && props.rover?.getPosition()?.y === y
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.gridSize, (row) => {
      return (_openBlock(), _createElementBlock("div", {
        key: row,
        class: "row"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.gridSize, (col) => {
          return (_openBlock(), _createElementBlock("div", {
            key: col,
            class: _normalizeClass(["cell", {
          rover: isRober(col - 1, row - 1),
          obstacle: isObstacle(col - 1, row - 1),
        }]),
            title: `(X:${col - 1}, Y:${row - 1})`
          }, null, 10, _hoisted_2))
        }), 128))
      ]))
    }), 128))
  ]))
}
}

})